const func = $target => {
	if ($target.find('a.cross-brand')[0]) {
		/* add class to header on scroll - for mini version of header */
		$(window).scroll(function() {
			var scroll = $(window).scrollTop();
			if (scroll >= 30) {
				$target.addClass('mini');
			} else {
				$target.removeClass('mini');
			}
		});
	}
};

export default func;
